import { useStore } from '@/store'
import './commonModal.scss'
import dialogPolyfill from 'dialog-polyfill'
import React, { ReactNode, useEffect, useRef } from 'react'

interface CommonModalProps {
  title: string
  open: boolean
  desc?: string
  type?:
    | 'common'
    | 'rule'
    | 'recall'
    | 'alert'
    | 'record'
    | 'share'
    | 'select-role'
    | 'receive'
  length?: 'normal' | 'long' | 'short'
  children?: ReactNode[]
  onBodyClick?: () => void
  onClose?: () => void
}
export default function CommonModal(props: CommonModalProps) {
  const { open, desc, title, type, length, children, onBodyClick, onClose } =
    Object.assign(
      {
        open: false,
        title: '',
        type: 'common',
        length: 'normal',
      },
      props
    )

  const id = `${type}-modal`

  const modalRef = useRef<HTMLDialogElement>(null)

  const { dispatch } = useStore()

  useEffect(() => {
    const modalElem = modalRef.current
    if (modalElem) {
      dialogPolyfill.registerDialog(modalElem)
      modalElem.onkeydown = (e) => {
        if (e.key === 'Escape') {
          e.preventDefault()
        }
      }
      if (open) {
        setTimeout(() => {
          if (document.activeElement.tagName === 'INPUT') {
            const input = document.activeElement as HTMLInputElement
            input.blur() // 取消聚焦
          }
          const inputElem = modalElem.querySelector('input')
          if (inputElem) {
            inputElem.readOnly = false
          }
        }, 4)
        modalElem.showModal()
      }
    }

    return () => {
      if (modalElem) {
        modalElem.open = false
      }
    }
  }, [open])

  const bodyHandleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation()
    onBodyClick instanceof Function && onBodyClick()
  }

  const close = () => {
    onClose instanceof Function && onClose()

    if (type === 'alert') return

    dispatch({
      type: 'closeModal',
    })
  }

  return open ? (
    <>
      <dialog
        ref={modalRef}
        id={id}
        className={`common-modal common-modal--${length}`}
        onClick={close}
      >
        <div className="common-modal-cont" onClick={bodyHandleClick}>
          {type === 'share' ? null : (
            <div className="common-modal-header">
              <span>{title}</span>
            </div>
          )}
          <div className="common-modal-body">{children[0]}</div>
          {children[1] ? (
            <div className="common-modal-footer">{children[1]}</div>
          ) : null}
        </div>
        {desc ? <div className="common-modal-desc">{desc}</div> : null}
        {type === 'alert' ? null : (
          <a
            id="common-modal-close"
            className="common-modal-close"
            autoFocus={true}
          ></a>
        )}
      </dialog>
      <div className="backdrop"></div>
    </>
  ) : null
}
